module.exports = __webpack_public_path__ + "static/alumni-f81df6210afde8d648249e07a1012479.webp";